import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";

import HdPageLoader from "@hd/ui-kit/hd-page-loader/HdPageLoader";

const DooryDashboardPage = lazy(
  () => import("./pages/doory-dashboard/DooryDashboardPage")
);
const DooryStatsPage = lazy(() => import("./pages/doory-stats/DooryStatsPage"));
function useDooryRoutes() {
  return (
    <>
      <Route
        path="doory-dashboard"
        element={
          <Suspense fallback={<HdPageLoader />}>
            <DooryDashboardPage />
          </Suspense>
        }
      />
      <Route
        path="doory-stats"
        element={
          <Suspense fallback={<HdPageLoader />}>
            <DooryStatsPage />
          </Suspense>
        }
      />
    </>
  );
}

export default useDooryRoutes;
